import Bar from "../states/Bar";

// Matches UpcomingListingCard box for box so the grid doesn't jump when the
// real cards land: 160px photo, then address / city / price / specs / meta and
// the agent footer under its divider.
const CardSkeleton = () => (
  <div className="flex flex-col overflow-hidden rounded-lg border border-light_gray bg-white shadow-card">
    <Bar w="100%" h={160} r={0} />
    <div className="flex flex-col p-3">
      <div className="flex h-5 items-center">
        <Bar w="70%" h={13} />
      </div>
      <div className="flex h-4 items-center">
        <Bar w="45%" h={10} />
      </div>
      <div className="mt-1 flex h-7 items-center">
        <Bar w={110} h={18} />
      </div>
      <div className="flex h-4 items-center">
        <Bar w="58%" h={10} />
      </div>
      <div className="mt-0.5 flex h-4 items-center">
        <Bar w="48%" h={9} />
      </div>
      <div className="mt-2 flex items-center gap-2 border-t border-light_gray pt-3">
        <Bar w={16} h={16} r={8} />
        <Bar w={90} h={10} />
      </div>
    </div>
  </div>
);

const UpcomingListingsSkeleton = ({ cards = 6 }) => (
  <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-3">
    {Array.from({ length: cards }, (_, i) => (
      <CardSkeleton key={i} />
    ))}
  </div>
);

export default UpcomingListingsSkeleton;
